// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Luxury_wrapper__3J89E","title-container":"Luxury_title-container___qG6x"};